module.exports = __webpack_public_path__ + "img/mate10lite.1693478d.jpg";